/**
 * Po nasazení nové verze má otevřená karta v paměti starou aplikaci, která odkazuje na části kódu
 * (chunky) z minulého buildu — na serveru už nejsou (404) a stránka by zůstala bílá. Řešení:
 * stránku jednou obnovit, tím se načte nový index.html s novými odkazy.
 *
 * Pojistka proti smyčce: obnovuje se nejvýš jednou za RELOAD_GUARD_MS (čas v sessionStorage).
 */
const KEY = 'das.staleReloadAt'
const RELOAD_GUARD_MS = 30_000

/** Chyba načtení části kódu (Chrome, Firefox, Safari mají každý jiné znění). */
export function isChunkLoadError(error: unknown): boolean {
  const msg = error instanceof Error ? `${error.name} ${error.message}` : String(error ?? '')
  return /Failed to fetch dynamically imported module|error loading dynamically imported module|Importing a module script failed|ChunkLoadError|Loading chunk .* failed|Unable to preload CSS/i.test(msg)
}

/** Obnoví stránku, pokud se tak nestalo před chvílí. Vrací true, když obnovuje. */
export function reloadForNewVersion(): boolean {
  let last = 0
  try { last = Number(sessionStorage.getItem(KEY) || 0) } catch { /* soukromý režim */ }
  if (Date.now() - last < RELOAD_GUARD_MS) return false
  try { sessionStorage.setItem(KEY, String(Date.now())) } catch { /* soukromý režim */ }
  window.location.reload()
  return true
}

/** Vite hlásí nenačtený chunk událostí `vite:preloadError` — obnovit místo bílé stránky. */
export function installStaleBuildReload(): void {
  window.addEventListener('vite:preloadError', (event) => {
    if (reloadForNewVersion()) event.preventDefault()
  })
}
